import React from 'react'
import { SvgIcon } from './SvgIcon'

interface Props {
  className?: string
}

export function Refresh({ className }: Props) {
  return (
    <SvgIcon className={className} viewBox="0 0 16 16">
      <path d="M13.3,3.43A7,7,0,1,0,15,8" fill="none" stroke="currentColor" strokeWidth="2" />
      <polygon points="15.2 0.8 15.2 5.6 10.4 5.6 15.2 0.8" fill="currentColor" />
    </SvgIcon>
  )
}
